export default __webpack_public_path__ + "static/media/Pending_icon1.ec558ae3.svg";